import axios from 'axios'
import { BUSCAR_ULTIMOS_HISTORICOS_ROTA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarUltimosHistoricosRota (rotaId, empresaId) {
  let url = `${URL}/rota/${rotaId}/empresa/${empresaId}/historicos`;
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ULTIMOS_HISTORICOS_ROTA,
        payload: response

      })
  );
}
